module.exports = __webpack_public_path__ + "uarm-css//tinymce/content.min.css";